import { ExternalLink, Landmark } from "lucide-react";
import { GoldButton } from "./Buttons";
import { IRS_NEWS } from "../data/content";

export default function NewsCard({ article, index = 0 }) {
    return (
        <article
            className="h-full flex flex-col bg-white border border-[#E7E4DC] rounded-xl p-7 shadow-sm hover:border-[#C8A45D]/60 hover:shadow-lg transition-[border-color,box-shadow] duration-300"
            data-testid={`news-card-${index}`}
        >
            <div className="flex items-center gap-2 flex-wrap">
                <span
                    className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.16em] font-semibold text-[#8A6D2F] bg-[#C8A45D]/10 px-2.5 py-1 rounded-full"
                    data-testid={`news-source-badge-${index}`}
                >
                    <Landmark className="h-3 w-3" /> {IRS_NEWS.sourceBadge}
                </span>
                {article.ir_number ? (
                    <span className="text-[10px] uppercase tracking-[0.14em] text-[#737985] border border-[#E7E4DC] px-2.5 py-1 rounded-full">
                        {article.ir_number}
                    </span>
                ) : null}
            </div>
            <h3 className="font-display text-lg sm:text-xl text-[#20242B] leading-snug mt-4" data-testid={`news-title-${index}`}>
                {article.title}
            </h3>
            <p className="text-[#8A6D2F] text-[11px] uppercase tracking-[0.14em] mt-3" data-testid={`news-date-${index}`}>
                {article.published_display || "IRS Newsroom"} <span className="text-[#9aa1ab] normal-case">· {IRS_NEWS.attribution}</span>
            </p>
            {article.summary ? (
                <p className="text-[#737985] text-sm leading-relaxed mt-3 flex-1">{article.summary}</p>
            ) : (
                <span className="flex-1" />
            )}
            <GoldButton asChild className="h-11 px-6 text-[12px] mt-6 self-start">
                <a href={article.url} target="_blank" rel="noopener noreferrer external" data-testid={`news-link-${index}`}>
                    {IRS_NEWS.readMore} <ExternalLink className="h-3.5 w-3.5" />
                </a>
            </GoldButton>
        </article>
    );
}
